const domParser = new DOMParser()

export default (api, url, domSelectorMap) => api(url).then(html => new Promise((resolve, reject) => {
  try {
    const document = domParser.parseFromString(html, 'text/html')
    resolve(Object.entries(domSelectorMap).reduce((map, [key, selector]) => {
      map[key] = [...document.querySelectorAll(selector)]
      return map
    }, {}))
  } catch (error) {
    reject(error)
  }
}))



// WEBPACK FOOTER //
// ./src/utils/crawler.js